import { useState } from 'react';

import { GrupoDeChips } from '../ds/GrupoDeChips.js';
import {
  ehEscala,
  gravarEscala,
  lerEscala,
  type Escala as Escolha,
} from '../ds/escala.js';
import './ajustes.css';

// O `GrupoDeChips` fala em `string` porque é o `value` de um rádio nativo; a
// escala é número. A conversão mora aqui, na fronteira, e não no genérico do
// componente — alargá-lo contaminaria todos os outros grupos, que são de
// texto por natureza.
const OPCOES: ReadonlyArray<{ valor: string; rotulo: string }> = [
  { valor: '100', rotulo: '100 %' },
  { valor: '125', rotulo: '125 %' },
  { valor: '150', rotulo: '150 %' },
  { valor: '175', rotulo: '175 %' },
];

export function Escala() {
  const [escala, setEscala] = useState<Escolha>(lerEscala);
  return (
    <section className="ajustes__secao">
      <GrupoDeChips
        nome="escala"
        rotulo="Escala de navegação"
        ajuda="Aumenta botões e alvos de toque sem mexer no tamanho do texto"
        opcoes={OPCOES}
        valor={String(escala)}
        aoMudar={(v) => {
          const valor = Number(v);
          // O estreitamento usa o mesmo validador de `escala.ts`: um `as`
          // aqui aceitaria calado qualquer opção mal digitada acima.
          if (!ehEscala(valor)) return;
          setEscala(valor);
          gravarEscala(valor);
        }}
      />
    </section>
  );
}
